import { useState, useRef, useEffect } from 'react';
import { useParams, Link } from "react-router-dom";
import { getProject } from '../../Data';
import emailjs from 'emailjs-com';
import { ReactComponent as Out } from '../Assets/Horizontal_switch.svg';


const ProjectView = () => {
    const params = useParams();
    let project = getProject(params.projectId);

    const form = useRef();
    const [message, setMessage] = useState('');
    const [alert, setAlert] = useState();
    const [theme, setTheme] = useState();
    const Color ={ "success":"bg-[#07bc0c]", "danger":"bg-[#e74c3c]" };
  
    const sendEmail = (e) => {
      e.preventDefault();
      if ( message ) {
          const serviceId = 'service_g66n9ro';
          const templateId = 'template_2dq9r1r';
          const publicKey = 'Uzx4fdYLrzsm9puW9';
          
          emailjs.sendForm(serviceId, templateId, form.current, publicKey)
          .then((result) => {
             setAlert('Thank you for your Comment!');
             setTheme(Color.success);
              setMessage('');
          }, (error) => {
            setAlert("Huh An Error Ocurred!!!" + error.text);
            setTheme(Color.danger);
          });
      } else {
        setAlert("Please fill.");
        setTheme(Color.danger);
      } 
  }

  const INTERVAL = 3000

  useEffect(() => {
    const interval = setInterval(() => {
    setAlert("");
    }, INTERVAL);
    return () => {
      clearInterval(interval);
  }
  });
  // console.log(project)

  return (
        <div className="flex text-sm sm:text-base text-left transform transition w-full md:px-4 md:my-8 md:align-middle md:max-w-5xl">
          
               <div className="w-full relative flex items-center pt-14 pb-8 sm:pt-8 ">
                 
                 <div className="w-full grid grid-cols-1 gap-y-8 gap-x-6 items-start sm:grid-cols-12 lg:gap-x-8">
                   
                   <div className="relative aspect-w-2 aspect-h-3 rounded-lg bg-gray-100 overflow-hidden sm:col-span-4 lg:col-span-5">
                     <img src={project.imgUrl} alt={project.imgAlt} className="object-center object-cover" />
                      {/* <div className="flex gap-1 items-center justify- float-right absolute top-2 z-50 right-2">
                        <Link to="/projects" className="bg-green-400 w-4 h-4 rounded-full"/>
                        <Link to="/projects" className="bg-yellow-400 w-4 h-4 rounded-full"/>
                        <Link to="/projects" className="bg-red-400 w-4 h-4 rounded-full"/>
                    </div> */}
                    <Link className='absolute z-50 top-2 right-2' to={`/projects`}>
                      <Out />
                    </Link>
                   </div>
                  
                   <div className="sm:col-span-8 lg:col-span-7">
                     <h2 className=" text-xl sm:text-2xl font-semibold sm:pr-12 capitalize">{project.name}</h2>
 
                     <section className="mt-2">
                       <p className="text-sm sm:text-base">{project.desc}</p>
                     </section>
                       <div className="my-3">
                              <code className=" flex flex-col">
                                  <span>01. &nbsp; 
                                    <span className='text-[#CCD2E3]'>&lt;stack&gt;</span>
                                  </span>
                                  <span>02. &nbsp; &nbsp;
                                    <span className="text-[#FF8098]">&lt;{project["stack "].backend} /&gt;</span>
                                  </span>
                                  <span>03. &nbsp; &nbsp; 
                                    <span className="text-[#F2C94C]">
                                      &lt;{project["stack "].frontend} /&gt;
                                    </span>
                                  </span>
                                  <span>04. &nbsp; &nbsp; 
                                    <span className="text-[#6AB980]">
                                      &lt;{project["stack "].state} /&gt;
                                    </span>
                                  </span>
                                <span>05. &nbsp; &nbsp; 
                                  <span className="text-[#2F80E1]">&lt;{project["stack "].styling} /&gt;</span>
                                </span>
                                  <span>06. &nbsp; 
                                    <span className='text-[#CCD2E3]'>&lt;/stack&gt;</span>
                                  </span>
                              </code>
                          </div>
                          {/* {project.stack} */}
 
                     <form ref={form} onSubmit={sendEmail} className="">
                     <div className={`shadow w-full my-2 z-50 ${ alert ? "flex bounce" : "hidden"} justify-center flex-row px-2 py-2 gap-2 items-center rounded-lg shadow ${theme}`}
>
                      <span className="flex-shrink-0 inline-flex item-center justify-center leading-none rounded-full ">
                      {theme === Color.danger ?
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill={`white`} className="h-8 w-8">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" ></path>
                          </svg>
                          :
                            <svg className="h-8 w-8 " viewBox="0 0 1020 1020" version="1.1" xmlns="http://www.w3.org/2000/svg">
                              <path fillRule="evenodd" d="M469.333333 640l0.384 0.384L469.333333 640z m-106.282666 0l-0.384 0.384 0.384-0.384z m48.512 106.666667a87.466667 87.466667 0 0 1-61.653334-24.874667l-179.52-173.632a67.797333 67.797333 0 0 1 0-98.24c28.032-27.157333 73.493333-27.157333 101.589334 0l139.584 134.997333 319.168-308.544c28.032-27.157333 73.493333-27.157333 101.589333 0a67.925333 67.925333 0 0 1 0 98.24L472.981333 722.069333A87.530667 87.530667 0 0 1 411.562667 746.666667z" fill="white" clipRule="evenodd" />
                            </svg>
                          }
                        </span>

                          <div className="flex-1 p-2 truncate">
                            <p className="text-sm truncate">{alert}</p>
                          </div>
                          
                         </div>
                            <input type="text" name='title' className="sr-only"
                              value={project.name} onChange={e => setMessage(e.target.value)}/>
                            <div className="relative ">
                                <textarea 
                                  type="text" 
                                  className={` block px-2.5 pb-2.5 pt-4 w-full text-sm bg-transparent rounded-lg border border-zinc-700 appearance-none focus:border-zinc-500 focus:outline-none focus:ring-0 focus:border-zinc-600 peer`} 
                                  placeholder=" "
                                  cols="0" rows="5"
                                  value={message} 
                                  name="message"
                                  onChange={e => setMessage(e.target.value)}
                                  />
                                  <label className="absolute text-xs text-zinc-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-zinc-700 rounded px-2 py-1 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:text-white peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-6 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-2">Drop a Comment</label>
                            </div>
                            
                      <div className="flex mt-6">
                        <button className="w-full bg-indigo-600 border border-transparent rounded-lg py-3 px-6 sm:px-8 mr-2 flex items-center justify-center text-sm sm:text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                          Send
                        </button>
                           <a href={project.viewDemo} target="_blank" rel="noopener noreferrer" className="text-decoration-none ml-2 position-absolute bottom-0 w-full bg-indigo-600 border border-transparent rounded-lg py-3 px-6 sm:px-8 flex items-center justify-center text-sm sm:text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ">
                            View Demo
                            </a>
                      </div>
                     </form>
                   </div>
                 </div>
               </div>
             </div>
  )
}

export default ProjectView;